import Vue from 'vue'
import Router from 'vue-router'
import Emulator from "@/components/Emulator";

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Emulator',
      component: Emulator
    }
  ]
});



// WEBPACK FOOTER //
// ./src/router/index.js